import { checkSnsDuplicate } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  CheckSnsDuplicateServiceRequest,
  CheckSnsDuplicateServiceResponse,
} from './check-sns-duplicate.dto';
import {
  CheckSnsDuplicateServiceRequestSchema,
  CheckSnsDuplicateServiceResponseSchema,
} from './check-sns-duplicate.dto';

const generateMessage = (isDuplicated: boolean, duplicatedUrls: string[]): string => {
  if (!isDuplicated) {
    return '사용 가능한 SNS URL입니다.';
  }

  if (duplicatedUrls.length === 1) {
    return `${duplicatedUrls[0]} URL이 이미 등록되어 있습니다.`;
  }

  return `${duplicatedUrls.length}개의 URL이 이미 등록되어 있습니다.`;
};

export const checkSnsDuplicateService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(CheckSnsDuplicateServiceRequestSchema),

    async (request: CheckSnsDuplicateServiceRequest): Promise<CheckSnsDuplicateServiceResponse> => {
      const { url } = request;

      const { data } = await checkSnsDuplicate({ urls: [url] });

      const message = generateMessage(data.isDuplicated, data.duplicatedUrls);

      return {
        isDuplicated: data.isDuplicated,
        duplicatedUrls: data.duplicatedUrls,
        message,
      };
    },

    validateServiceResponse(CheckSnsDuplicateServiceResponseSchema),
  ),
);
